export default __webpack_public_path__ + "static/countdown_web-8f4ef818a4f717cf88910dc43db9bbce.png";